import { ApplicationControlType, ControlType } from "../components/auth/types";

const DtectionClientId = "DtectionClientId";
const DtectionRole = "Role";

const extractRoles = (control: ControlType | undefined): string[] | null =>
  control?.values
    ?.map((v) => v.name)
    .filter((name): name is string => !!name) || null;

const filterValidValues = (values: string[]): string[] =>
  values.map((v) => v.trim()).filter((v) => v && v !== ",");

const extractPermissionsFromValues = (values: ControlType[] = []): string[] => {
  return values.flatMap((value) =>
    value.value ? filterValidValues(value.value.split(",")) : [],
  );
};

const extractRolesAndPermissions = (
  data?: ApplicationControlType,
): {
  userRoles: string[] | null;
  userPermissions: string[] | null;
  clientIds: string[] | null;
} => {
  if (!data) {
    return {
      userRoles: [],
      userPermissions: [],
      clientIds: [],
    };
  }

  const roleControl = data?.controls.find((c) => c.name === DtectionRole);
  const clientControl = data?.controls.find((c) => c.name === DtectionClientId);

  const roles = extractRoles(roleControl);
  const permissions = extractPermissionsFromValues(roleControl?.values);
  const clientIds = extractPermissionsFromValues(clientControl?.values);

  return {
    userRoles: roles,
    userPermissions: permissions,
    clientIds,
  };
};

export default extractRolesAndPermissions;
